var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _circle, _path19, _path20;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVideo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.6775 8.78958V26.036C28.6775 26.5741 28.4637 27.0902 28.0832 27.4707C27.7027 27.8512 27.1866 28.0649 26.6485 28.0649H7.37316C6.83504 28.0649 6.31896 27.8512 5.93845 27.4707C5.55794 27.0902 5.34418 26.5741 5.34418 26.036V8.78958H28.6775Z",
    fill: "#D9EEF7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.86597 24.5142H27.1558",
    stroke: "#4C5B66",
    strokeWidth: 0.940153,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4601 26.0359V22.9925",
    stroke: "#4C5B66",
    strokeWidth: 0.940153,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0398 17.4127L14.9818 19.4417V15.3838L19.0398 17.4127Z",
    fill: "#D9EEF7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6485 12.3403V22.4852H7.37317V12.3403C7.37397 12.0715 7.48111 11.8139 7.67119 11.6238C7.86127 11.4338 8.11885 11.3266 8.38766 11.3258H25.634C25.9029 11.3266 26.1604 11.4338 26.3505 11.6238C26.5406 11.8139 26.6477 12.0715 26.6485 12.3403Z",
    fill: "#4C5B66"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6485 22.4852V12.3403C26.6477 12.0715 26.5406 11.8139 26.3505 11.6238C26.1604 11.4338 25.9029 11.3266 25.634 11.3258H8.38766C8.11885 11.3266 7.86127 11.4338 7.67119 11.6238C7.48111 11.8139 7.37397 12.0715 7.37317 12.3403V22.4852",
    stroke: "#4C5B66",
    strokeWidth: 0.663638,
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6568 19.1163C16.2223 19.4639 15.5786 19.1545 15.5786 18.5981V15.6307C15.5786 15.0743 16.2223 14.7649 16.6568 15.1125L18.5114 16.5962C18.8435 16.8618 18.8435 17.3669 18.5114 17.6326L16.6568 19.1163Z",
    fill: "#59A5EE"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6485 4.7316H7.3731C6.25252 4.7316 5.34412 5.64001 5.34412 6.76058V26.0359C5.34412 27.1565 6.25252 28.0649 7.3731 28.0649H26.6485C27.769 28.0649 28.6774 27.1565 28.6774 26.0359V6.76058C28.6774 5.64001 27.769 4.7316 26.6485 4.7316Z",
    stroke: "#4C5B66",
    strokeWidth: 0.940153,
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M6.86597 8.78958H27.1558",
    stroke: "#4C5B66",
    strokeWidth: 0.940153,
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M7.37317 6.76062H8.38766",
    stroke: "#4C5B66",
    strokeWidth: 0.940153,
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M9.40216 6.76062H10.4167",
    stroke: "#4C5B66",
    strokeWidth: 0.940153,
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M25.634 6.76062H26.6485",
    stroke: "#4C5B66",
    strokeWidth: 0.940153,
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3502 4.7316C28.0832 4.7316 28.6775 5.32584 28.6775 6.05887V25.6088C28.6775 26.2602 28.4637 26.8849 28.0832 27.3455C27.7027 27.8062 27.1866 28.0649 26.6485 28.0649H7.3731C6.83498 28.0649 6.3189 27.8062 5.93839 27.3455C5.55788 26.8849 5.34412 26.2602 5.34412 25.6088V6.05887C5.34412 5.32584 5.93836 4.7316 6.67139 4.7316H27.3502Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M6.86584 25.2303H27.1557",
    stroke: "#4C5B66",
    strokeWidth: 0.663638,
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0398 17.4128L14.9818 19.4418V15.3838L19.0398 17.4128Z",
    fill: "#D9EEF7"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6485 4.7316H7.3731C6.25252 4.7316 5.34412 5.64001 5.34412 6.76058V26.0359C5.34412 27.1565 6.25252 28.0649 7.3731 28.0649H26.6485C27.769 28.0649 28.6774 27.1565 28.6774 26.0359V6.76058C28.6774 5.64001 27.769 4.7316 26.6485 4.7316Z",
    stroke: "#4C5B66",
    strokeWidth: 0.940153,
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M6.86597 8.78958H27.1558",
    stroke: "#4C5B66",
    strokeWidth: 0.663638,
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M7.37317 6.76062H8.38766",
    stroke: "#4C5B66",
    strokeWidth: 0.940153,
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M9.40216 6.76062H10.4167",
    stroke: "#4C5B66",
    strokeWidth: 0.940153,
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M25.634 6.76062H26.6485",
    stroke: "#4C5B66",
    strokeWidth: 0.940153,
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13.0723,
    cy: 25.3497,
    r: 1.45846,
    fill: "#0C131A",
    stroke: "#4C5B66",
    strokeWidth: 0.663638
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M26.7046 11.777L26.7046 21.516C26.7046 22.0658 26.2589 22.5115 25.7092 22.5115H8.31257C7.76279 22.5115 7.31711 22.0658 7.31711 21.516V11.7766C7.31782 11.5662 7.39795 11.3677 7.53545 11.2235C7.67243 11.0798 7.85457 11.0019 8.04118 11.0012H25.9805C26.1672 11.0019 26.3493 11.0798 26.4863 11.2235C26.6237 11.3676 26.7039 11.5661 26.7046 11.7764C26.7046 11.7766 26.7046 11.7768 26.7046 11.777Z",
    fill: "#D05F58",
    stroke: "#5D5D5D",
    strokeWidth: 0.663638
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4015 19.0821C15.9605 19.3761 15.3698 19.06 15.3698 18.5299V15.2811C15.3698 14.751 15.9605 14.4349 16.4015 14.7289L18.8382 16.3533C19.2322 16.616 19.2322 17.195 18.8382 17.4577L16.4015 19.0821Z",
    fill: "#F0F0F0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideo);
export default __webpack_public_path__ + "static/media/video.ccbd4f7e5fe365cf6b02ae7353d0a8b9.svg";
export { ForwardRef as ReactComponent };